$(document).ready(function () {
    // The date after which the logo should be changed
    const targetDate = new Date('2025-01-01T00:00:00');
    // The current date
    const currentDate = new Date();

    const navbarLogo = $('#navbar-logo');
    const mainHeaderLogo = $('.main-header__logo.logo');

    if (currentDate >= targetDate) {
        function changeLogo(element) {
            const svgElement = element.find('svg');
            const useElement = svgElement.find('use');

            if (useElement.length && svgElement.length) {
                const markupEnv =
                    window.location.origin.includes('localhost') ||
                    window.location.origin === 'https://dev.profit.org.ru';
                const baseUrl =
                    window.location.origin + '/wp-content/themes/hagerty-uk';
                const logoHref = markupEnv
                    ? 'assets/svg/symbols.svg#header-logo'
                    : baseUrl + '/assets/svg/symbols.svg#header-logo';
                const logoWidth = '116';
                const ariaLabelValue = 'Hagerty Logo';

                useElement.attr('xlink:href', logoHref);

                svgElement.attr('width', logoWidth);

                element.attr('aria-label', ariaLabelValue);

                element.addClass('active');
            }
        }

        changeLogo(navbarLogo);
        changeLogo(mainHeaderLogo);
    } else {
        navbarLogo.addClass('active');
        mainHeaderLogo.addClass('active');
    }
});
